import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { hideToast } from '@core/errors/models/context';

@Injectable({
  providedIn: 'root',
})
export class AutoRenewNotificationsService {
  private readonly httpClient = inject(HttpClient);

  getPublishSubscribeClientAccessUrl(): Observable<string> {
    const url = 'api/v1/asset-notifications/pub-sub-connection';

    return this.httpClient.get(environment.portalApiUrl + url, { responseType: 'text', context: hideToast() });
  }
}
